import React, { Component } from 'react'
import { connect } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Header from '../common/Header/Header';
import Sidebar from '../common/Sidebar/Sidebar';
import Content from '../common/Content/Content';

import styles from '../../commonModules/Spinner.module.css';
import TicketsView from '../Tickets/TicketsView';

class Dashboard extends Component {
  renderer = (route) => {
    switch(route) {
      case "tickets":
        return (
        <TicketsView 
          columns={[/*"ID", "User", "Date", "Status", "Reason"*/]}
          tickets={[[/*"11", "Some", "11/11/2015", TicketsView.statuses.pending, "for a reason"*/]]}
          />)
      default: return <Content />
    }
  }
  render() {
    return (
      <div className={`${this.props.user.loading? styles.spinner : ''}`}>
        <Header />
        <Sidebar />
          {this.renderer(this.props.route)}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)